class BlockType {
	static Invalid = 0;
	static SpotBlock = 1;
	static NetworkSpotBlock = 2;
}

export default BlockType;